// extracted by css-extract-rspack-plugin
export default {"currentAnchor":"currentAnchor-tnx3Vw","menu":"menu-mOkMOc","title":"title-sbm4eb","subTitle":"subTitle-NieaXF","link":"link-nmKuUH","item":"item-1km7kE","state":"state-HgheMz"};